export class LoanApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoan({ loanNumber }) {
    return this.#http.get(`/loan/${loanNumber}`);
  }

  async getLoanBorrowers() {
    return this.#http.get('/loan/loan-borrowers');
  }

  async searchLoanApplications({ query, take = 20 }) {
    return this.#http.get('/loan/search', { params: { query, take } });
  }
}
